export default function({
  x, y,
  w, h, r,
  lineWidth, lineColour, lineAlpha,
  fillColour, fillAlpha
}) {
  const halfLineWidth = ( lineWidth || 0 ) / 2;
  const lt = ( x || 0 ) + halfLineWidth;
  const tp = ( y || 0 ) + halfLineWidth;
  const rt = ( x || 0 ) + w - halfLineWidth;
  const bm = ( y || 0 ) + h - halfLineWidth;

  const g = new PIXI.Graphics();
  
  if ( lineWidth ) {
    g.lineStyle(lineWidth, lineColour, lineAlpha);
  }

  if ( typeof fillColour !== 'undefined' ) {
    g.beginFill(fillColour, fillAlpha);
  }
  g
  .moveTo(lt + r, tp)
  .lineTo(rt - r, tp)             // top
  .arcTo(rt, tp, rt, tp + r, r)   // top-right corner
  .lineTo(rt, bm - r)             // right
  .arcTo(rt, bm, rt - r, bm, r)   // bottom-right corner
  .lineTo(lt + r, bm)             // bottom
  .arcTo(lt, bm, lt, bm - r, r)   // bottom-left corner
  .lineTo(lt, tp + r)             // left
  .arcTo(lt, tp, lt + r, tp, r);  // top-left corner

  if ( typeof fillColour !== 'undefined' ) {
    g.endFill();
  }

  return g;
};
